<template>
  <div class="view-387">
    <div class="rectangle-82-21"></div>
    <div class="x1-35 poppins-semi-bold-white-10px">10+</div>
  </div>
</template>

<script>
export default {
  name: "View41",
};
</script>

<style>
.view-387,
.view-388,
.view-389,
.view-390,
.view-391,
.view-392,
.view-393,
.view-394,
.view-395,
.view-396,
.view-397,
.view-398,
.view-399,
.view-400,
.view-401 {
  height: 19px;
  left: 25.13%;
  position: absolute;
  top: 0;
  width: 4.23%;
}

.rectangle-82-21,
.rectangle-82-22,
.rectangle-82-23,
.rectangle-82-24,
.rectangle-82-25,
.rectangle-82-26,
.rectangle-82-27,
.rectangle-82-28,
.rectangle-82-29,
.rectangle-82-30,
.rectangle-82-31,
.rectangle-82-32,
.rectangle-82-33,
.rectangle-82-34,
.rectangle-82-35 {
  background-color: var(--coral-red-2);
  border: 1.5px solid;
  border-color: var(--white);
  border-radius: 60px;
  height: 19px;
  left: 0;
  position: absolute;
  top: 0;
  width: 93.75%;
}

.x1-35,
.x1-36,
.x1-37,
.x1-38,
.x1-39,
.x1-40,
.x1-41,
.x1-42,
.x1-43,
.x1-44,
.x1-45,
.x1-46,
.x1-47,
.x1-48,
.x1-49 {
  height: 78.95%;
  left: 25%;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 10.53%;
  width: 53.12%;
}
</style>
